import "./DataView.css";
import { useContext, useEffect, useState } from "react";
import { Store } from "../../store";
import { DownloadOutlined,LoadingOutlined } from '@ant-design/icons';

//AntD
import { Button,Dropdown,Menu,Select,Spin } from "antd";

//Router
import { useLocation } from "react-router-dom";

//Lodash
import { round } from "lodash";

import axios from "../../service/axios";
import { toast } from "react-toastify";

import { faTrashCan, faLayerGroup, faCubesStacked, faTableCellsLarge } from "@fortawesome/free-solid-svg-icons";

import {pixelsToUnits, sortBinsByPosition, transformElements } from "../../utils/helpers";

import { onSaveLayoutObject, getLayoutObjects } from "../../services/layoutObjectsService";
import Loader from "../Loader/Loader";
import DataTable from "../../shared/components/DataTable/DataTable";
import BreadCrumb from "../../shared/components/BreadCrumb/BreadCrumb";
import Drawer from "../../shared/components/Drawer/Drawer";
import DataForm from "./DataForm/DataForm";
import { onRemoveElement } from "../../services/layoutObjectsService";

import AppModal from "../../shared/components/app-modal/AppModal";
import Confirmation from "../../shared/components/confirmation/Confirmation";
import BarCodesPreview from "../BarCodesPreview/BarCodesPreview";
import BarCode from "../BarCode/BarCode";
import QrCode from "../QrCode/QrCode";

//Columns
import { RackTableConfig, wallTableConfig, binTableConfig, areaTableConfig, dockTableConfig, subAreaTableConfig } from "./TableConfig";
import useQueryParams from "../../hooks/useQueryParams";

const DataView = (props) => {  
  // Declaring initial state inside the component
  const initialTabData = {
    parentTableRecords: [],
    childTableRecords: [],
    selectedRecordType: '',
    selectedParentRecord: {},
    selectedChildRecord: {}
  };

  const { activeTab, elementType } = props;
  const queryParams = useQueryParams();
  const location = useLocation();
  const { state, dispatch } = useContext(Store);
  const [loading, setLoading] = useState(false);
  const [childTableLoading, setChildTableLoading] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState(null);

  
  const [tabData,setTabData] = useState(initialTabData);

 //Scannable Label
  const [scannableLabelType, setScannableLabelType] = useState("BARCODE");

  //Dialog Content
  const [dialogData, setDialogData] = useState(null);

  //loader fir generating bins
  const [isLoading, setIsLoading] = useState(false);

  const isParentTableRecordSelected = Object.keys(tabData?.selectedParentRecord)?.length > 0;

  const componentToView = (component_name) => {
    const components = {
      BARCODE_PREVIEW: <BarCodesPreview barcodes={dialogData?.locations} labelType={scannableLabelType} name={dialogData?.element?.name}  />,
      BARCODE: scannableLabelType === "BARCODE" && <BarCode text={dialogData?.location} showActions={true} /> || <QrCode value={dialogData?.location} showActions={true} />,
    };
    return components[component_name];
  };


  //Table config
  const configActions = {
    onEdit: (element, type) => {
      let payload = {};
      switch (type) {
        case "rack":
          payload = { active: true, title: "Edit Rack", data: element, type: "rack", mode: "edit" };
          break;
        case "bin":
          payload = { active: true, title: "Edit Bin", data: element, type: "bin", mode: "edit" };
          break;
        case "area":
          payload = { active: true, title: "Edit Area", data: element, type: "area", mode: "edit" };
          break;
        case "subArea":
          payload = { active: true, title: "Edit SubArea", data: element, type: "subArea", mode: "edit" };
          break;
        case "wall":
          payload = { active: true, title: "Edit Wall", data: element, type: "wall", mode: "edit" };
          break;
        case "dock":
          payload = { active: true, title: "Edit Dock", data: element, type: "dock", mode: "edit" };
          break;
      }
      setDrawerData(payload);
    },
    onDeleteAction: (record, type) => {
      if (type === "rack" || type === "bin") {
        setDeleteRecord({ record, type, layoutObjectId: record?.rackId });
      }
    },
    onGenerateBins: (record) => {
      setDrawerData({ active: true, title: "Genearate Bins", data: record, type: "generateBins", mode: "create" });
    },
    onPrintMultipletLocations:(element)=>{
      const locations = element?.bins || element?.subAreas;
      setDialogData({ title: "Labels Preview", component_name: "BARCODE_PREVIEW", isModalActive: true, dilogWidth: 1000,element,locations:locations });
    },

    onPrintSingleLocation :(element)=>{
      setDialogData({ title: "Label Preview", component_name: "BARCODE", isModalActive: true, dilogWidth: 350,element,location:element?.code });
    },

    onChangeLabelType:(element,type)=>{
      setScannableLabelType(type);
      if(element?.objectType === "rack" || element?.objectType === "area"){
        configActions.onPrintMultipletLocations(element); //multiple locations are present
      }else{
        configActions.onPrintSingleLocation(element); //single location
      }
    }
  };

  const storageLocations = (elements,labelType) =>{
    const records = elements.flatMap((element)=> element.objectType === labelType ? element : element[labelType]);
    return records;
  }

  //Based on elementType table config will be set to table
  const tableConfig = {
    rack: RackTableConfig(configActions),
    wall: wallTableConfig(configActions),
    area: areaTableConfig(configActions),
    dock: dockTableConfig(configActions),
    bin: binTableConfig(configActions),
    subArea:subAreaTableConfig(configActions)
  };

  const childTableConfig = () => {
    if(tabData?.selectedRecordType === 'rack'){
      return tableConfig["bin"];
    }else if(tabData?.selectedRecordType === 'area'){
      return tableConfig["subArea"];
    }
  };

  const viewBreadCrumbItems = (currentClickType) => {
    const BreadCrumbItems = [
      { label: "BINS", icon: faCubesStacked },
      { label: "SUBAREAS", icon: faTableCellsLarge }
    ];

    const ItemsToView = {
      rack: BreadCrumbItems.slice(0, 1),
      area: BreadCrumbItems.slice(1, 2),
    };
    return ItemsToView[currentClickType];
  };

  let Items = viewBreadCrumbItems(tabData?.selectedRecordType);
 
 const downloadAllLocations = (labelType) => {
  const locations = storageLocations(tabData.parentTableRecords,labelType);
  setDialogData({ title: "Labels Preview", component_name: "BARCODE_PREVIEW", isModalActive: true, dilogWidth: 1000,locations });
 };

  const onCloseDrawer = () => {
    setDrawerData({});
  };

  const onDelete = () => {};

  const onCloseDialogHandler = () =>{
    setDialogData({})
  };

  const onConfirmDialogHandler = () =>{}

  const _sort = (records) =>{
    return records.sort((a,b)=>a.id-b.id) || [];
  }

  //Sort Elements
  const sortElements = (records) =>{
    const sortedElements = _sort(records); //Sort Elements
    if(elementType === 'rack'){
      return sortedElements?.map(element => ({...element,bins:sortBinsByPosition(element?.bins)}));
    }else if(elementType === 'area'){
      return sortedElements?.map(element => ({...element,subAreas:_sort(element?.subAreas)}));
    }
    return sortedElements;
  }


  //Row Selection
  const onRowClick = (row) =>{
    if(!(row?.bins?.length || row?.subAreas?.length)) return; //bins and subAreas must be present

    if(tabData.selectedParentRecord?.id !== row.id){
      const childRecords = elementType === 'rack' ? row?.bins : row?.subAreas;
      setTabData({...tabData,selectedParentRecord:row,childTableRecords:childRecords,selectedRecordType:row.objectType});
    }else{
      setTabData({...initialTabData,parentTableRecords:tabData.parentTableRecords});
    }
  }


  const convertDimension = (value, unitType) => {
    return round(pixelsToUnits(value, unitType), 2);
  };

  
  const transformBins = (bins,unitType) => {
    return bins.map((bin)=>({
      ...bin,
      width:convertDimension(bin.width,unitType),
      height:convertDimension(bin.height,unitType),
      positionX:convertDimension(bin.positionX,unitType),
      positionY:convertDimension(bin.positionY,unitType)
    })) || []
  }

  const transformSubAreas = (subAreas,unitType) => {
    return subAreas.map((subArea)=>({
      ...subArea,
      width:convertDimension(subArea.width,unitType),
      height:convertDimension(subArea.height,unitType),
      positionX:convertDimension(subArea.positionX,unitType),
      positionY:convertDimension(subArea.positionY,unitType)
    })) || []
  }


  const transformElementsUnitConversion = (elements) =>{
    return elements.map((element)=>{
      if (!element || typeof element !== 'object') return element;
      const width = convertDimension(element.width,element.unitType);
      const length = convertDimension(element.length,element.unitType);
      const positionX = convertDimension(element.positionX,element.unitType);
      const positionY = convertDimension(element.positionY,element.unitType);
      const transformedElement = {...element,width,length,positionX,positionY};
      if(elementType === 'rack'){
        return {...transformedElement,bins:transformBins(element.bins,element.unitType)}
      }else if(elementType === 'area'){
         return {...transformedElement,subAreas:transformSubAreas(element.subAreas,element.unitType)}
      }
      return {...transformedElement};
    })
  }

  const fetchLayoutObjects = async (layoutId,signal) =>{
    try{
      setLoading(true);
      const responseData = await getLayoutObjects(layoutId,signal);
      if(!signal.aborted){
        return responseData || [];
      }

    }catch(err){
        console.log(err);
        return [];
    }finally{
      if(!signal.aborted){
        setLoading(false);
      }
    }
  }



  //ORIGINAL CODE
  useEffect(()=>{
    const controller = new AbortController();
    const signal = controller.signal;
    async function handleLayoutData() {
    try {
      const layoutId = queryParams?.layoutId;
      const layoutObjects = await fetchLayoutObjects(layoutId, signal);
      
      if (!signal.aborted) {
        const transformedElements = transformElements(layoutObjects);
        dispatch({
          type: "BATCH_DISPATCH",
          payload: [
            { type: "SET_ELEMENTS", payload: transformedElements },
            { type: "SET_INITIAL_LOAD", payload: true },
          ],
        });
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error(err);
        toast.error("Error fetching layout objects");
      }
    }
  }
  
  handleLayoutData();

    return () => controller.abort(); 
  
  },[activeTab])


  useEffect(()=>{
    if(!state.elements?.length) return;
    //filter elements based on elementType
    const filteredElements = state.elements.filter((element) => element.objectType === elementType) || [];
   
    const unitConversionElements = transformElementsUnitConversion(filteredElements);
    //sort elements
    const sortedElements = sortElements(unitConversionElements);
    const subElementsMapping = {rack:"bins",area:"subAreas"};
    const subElement = subElementsMapping[elementType];
    if(isParentTableRecordSelected && subElement){
      const selectedParentRecord = sortedElements.find((element) => element.id === tabData.selectedParentRecord.id);
      setTabData({...tabData,parentTableRecords:sortedElements,childTableRecords:selectedParentRecord[subElement]});
      return;
    }
    setTabData({...tabData,parentTableRecords:sortedElements});

  },[state.elements])


  const menu = ( ) => {
    // This function will be called by the actual action items in the submenus
    const onSelectTypeAndDownload = async (labelTypeToExport, labelType) => {
      setIsLoading(true);
      setScannableLabelType(labelTypeToExport);
      try {
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 2000);
        });
        downloadAllLocations(labelType);
      } catch (error) {
        console.error(`${labelTypeToExport} generation error:`, error);
      } finally {
        setIsLoading(false);
      }
    };

    const LABEL_TYPES_TO_EXPORT = {
      AREA_BARCODE: 'BARCODE',
      SUBAREA_BARCODE: 'BARCODE',
      AREA_QRCODE: 'QRCODE',
      SUBAREA_BARCODE_FROM_QR_MENU: 'BARCODE',
      RACK_BARCODE: 'BARCODE',
      RACK_QRCODE: 'QRCODE',
    };
    
  
    // Configuration for menu items based on elementType
    const menuConfig = {
      area: [
        {
          key: 'barcode_actions',
          title: 'Barcode',
          items: [
            {
              key: 'download_area_barcode',
              label: 'Areas',
              onClick: () => onSelectTypeAndDownload('BARCODE','area'),
            },
            {
              key: 'download_subarea_barcode',
              label: 'SubAreas',
              onClick: () => onSelectTypeAndDownload(LABEL_TYPES_TO_EXPORT.SUBAREA_BARCODE,'subAreas'),
            },
          ],
        },
        {
          key: 'qrcode_actions',
          title: 'QR Code',
          items: [
            {
              key: 'download_area_qrcode',
              label: 'Areas',
              onClick: () => onSelectTypeAndDownload(LABEL_TYPES_TO_EXPORT.AREA_QRCODE,'area'),
            },
            {
              key: 'download_barcode_from_qr', 
              label: 'SubAreas',
              onClick: () => onSelectTypeAndDownload(LABEL_TYPES_TO_EXPORT.SUBAREA_BARCODE_FROM_QR_MENU,'subAreas'),
            },
          ],
        },
      ],
      rack: [
        {
          key: 'download_rack_barcode',
          label: 'Barcode',
          onClick: () => onSelectTypeAndDownload(LABEL_TYPES_TO_EXPORT.RACK_BARCODE,'bins'),
        },
        {
          key: 'download_rack_qrcode',
          label: 'QR Code',
          onClick: () => onSelectTypeAndDownload(LABEL_TYPES_TO_EXPORT.RACK_QRCODE,'bins'),
        },
      ],
    };
  
    const itemsToRender = menuConfig[elementType] || [];
  
    return (
      <Menu>
        {itemsToRender.map((itemOrSubMenu) => {
          // If 'items' array exists, it's a SubMenu
          if (itemOrSubMenu.items) {
            return (
              <Menu.SubMenu key={itemOrSubMenu.key} title={itemOrSubMenu.title}>
                {itemOrSubMenu.items.map((subItem) => (
                  <Menu.Item key={subItem.key} onClick={subItem.onClick}>
                    {subItem.label}
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            );
          }
          // Otherwise, it's a direct Menu.Item
          return (
            <Menu.Item key={itemOrSubMenu.key} onClick={itemOrSubMenu.onClick}>
              {itemOrSubMenu.label}
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

    const renderExportLocations = () =>{
      const allowedTypes = ['rack','area'];
      const hasElementType = allowedTypes.includes(elementType);
      if(!hasElementType) return;
      return (
      <Dropdown overlay={menu()} trigger={["click"]}>
        <Button type="primary" size="medium" loading={isLoading} icon={ !isLoading && <DownloadOutlined />}  iconPosition="start">
          {isLoading ? `Generating labels` : 'Export'}
        </Button>
      </Dropdown>)
    }


  return (
    <div className="data-view-container">
      {/* DataView : {elementType} */}
      <div className="data-view-table">
        <div className="parent-table" style={{ width: isParentTableRecordSelected ? "50%" : "100%" }} >
          <div className="table-title-wrapper">
            <div style={{display:'flex,align-items:center'}}>
            <h2 className="table-title">{elementType.toUpperCase()}</h2>
            </div>
            {renderExportLocations()}
          </div>
          <DataTable
            loading={loading}
            columns={tableConfig[elementType]}
            rows={tabData?.parentTableRecords}
            onRowClick={(record) => onRowClick(record)}
            selectedRow={tabData?.selectedParentRecord}
          />
        </div>
        {
          isParentTableRecordSelected && (
            <div className="child-table">
              <div className="table-title-wrapper">
                <BreadCrumb items={Items} seperatorIcon={">"} />
                {/* <Button type="primary" size="medium" disabled={onDisableCreateBtn()}>Create</Button> */}
              </div>
              <DataTable loading={childTableLoading} columns={childTableConfig()} rows={tabData?.childTableRecords} onRowClick={(record) => onRowClick(record)} />
            </div>
          )
        }
      </div>

      <Drawer title={drawerData?.title} open={drawerData?.active} onClose={onCloseDrawer} isMask={false} isMaskClosable={false}>
        {drawerData && (
          <DataForm data={drawerData?.data} dataViewElements={tabData} mode={drawerData?.mode} type={drawerData?.type} onCloseDrawer={onCloseDrawer} />
        )}
      </Drawer>

      {dialogData?.isModalActive && (
        <AppModal
          title={dialogData?.title}
          width={dialogData?.dilogWidth}
          isModalActive={dialogData?.isModalActive}
          onHandleModalClose={onCloseDialogHandler}
          onHandleModalSubmit={onConfirmDialogHandler}
          showCancelLabel={dialogData?.showCancelLabel}
          showConfirmLabel={dialogData?.showConfirmLabel}
          cancelLabel={dialogData?.cancelLabel}
          confirmLabel={dialogData?.confirmLabel}
        >
          {componentToView(dialogData?.component_name)}
        </AppModal>
      )}

      <AppModal
        width={400}
        isModalActive={deleteRecord}
        onHandleModalClose={() => setDeleteRecord(null)}
        onHandleModalSubmit={onDelete}
        showCancelLabel={true}
        showConfirmLabel={true}
        confirmLabel={"Yes, Delete"}
        cancelLabel={"No,Keep it"}
        isSubmitActionLoader={loading || childTableLoading}
      >
        <Confirmation
          icon={faTrashCan}
          subText={`Are you sure you want to delete this "${deleteRecord?.type}" ?`}
          title={`Delete ${deleteRecord?.record?.name}`}
          showFooter={true}
        />
      </AppModal>
      {/* {loading && !deleteRecord && <Loader />} */}
    </div>
  );
};

export default DataView;
